export default __webpack_public_path__ + "static/media/MonarcaClosed.305350be.jpg";